import { IconBaseType } from "@/v2-components/core/icon/type";
import { cn } from "@/libs/utils";

export default function ChevronDownIcon({ className }: IconBaseType) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("w-6 h-6", className)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0652 14.9439L18 10.0516L16.9348 8.99548L12 13.8879L7.06523 8.99548L6 10.0516L10.9348 14.9439L12 16L13.0652 14.9439Z"
        fill="currentColor"
      />
    </svg>
  );
}
